// components/compliance/DataHandlingNotice.jsx
import React from "react";

/**
 * HIPAA Data Handling Notice
 * Reminds users of their compliance responsibilities when handling PHI data.
 */
const DataHandlingNotice = () => {
  return (
    <div className="mt-4 p-3 bg-light rounded">
      <h6 className="text-muted">Data Handling Notice:</h6>
      <ul className="small text-muted mb-0">
        <li>All actions on this page are logged for audit purposes</li>
        <li>
          Do not share, screenshot, or export this information outside approved
          channels
        </li>
        <li>
          Report any suspected privacy breaches immediately to your Privacy
          Officer
        </li>
        <li>Access is limited to the minimum necessary for job duties</li>
      </ul>
    </div>
  );
};

export default DataHandlingNotice;
